import { TAttachmentsState, TAttachmentsActions } from '../../types/attachments';

export const attachmentsActionTypes = {
  GET_ATTACHMENTS_REQUEST: 'ATTACHMENTS/GET_ATTACHMENTS_REQUEST',
  GET_ATTACHMENTS_SUCCESS: 'ATTACHMENTS/GET_ATTACHMENTS_SUCCESS',
  SET_LOADING: 'ATTACHMENTS/SET_LOADING',
} as const;

const initialState: TAttachmentsState = {
  attachments: [],
  loading: false,
};

export default (
  state: TAttachmentsState = initialState,
  action: TAttachmentsActions,
): TAttachmentsState => {
  switch (action.type) {
    case attachmentsActionTypes.GET_ATTACHMENTS_SUCCESS:
      return {
        ...state,
        attachments: action.payload as any,
      };

    case attachmentsActionTypes.SET_LOADING:
      return {
        ...state,
        loading: action.payload,
      };
    default:
      return state;
  }
};

export const actions = {
  getAttachmentsRequest: (payload: 'ROOM' | 'DIRECT_CHAT') => ({
    payload,
    type: attachmentsActionTypes.GET_ATTACHMENTS_REQUEST,
  }),
};
